export const I18N_LANGUAGE_KEY = "i18n_language";
/** Marca gravada só quando a pessoa escolhe o idioma no seletor. */
export const I18N_LANGUAGE_EXPLICIT_KEY = "i18n_language_explicit";
export const IDIOMA_PADRAO = "pt-BR";

export type IdiomaSuportado = "pt-BR" | "en" | "es";

type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function suportado(v: string | null): v is IdiomaSuportado {
  return v === "pt-BR" || v === "en" || v === "es";
}

/**
 * Idioma inicial: pt-BR por padrão, sem olhar o navegador.
 * Só respeita o idioma salvo quando ele veio do seletor (marca explícita).
 * Migração: `i18n_language` sem a marca veio da detecção automática antiga e é descartado.
 */
export function resolverIdiomaInicial(storage: StorageLike | null | undefined): IdiomaSuportado {
  if (!storage) return IDIOMA_PADRAO;
  try {
    const salvo = storage.getItem(I18N_LANGUAGE_KEY);
    const explicito = storage.getItem(I18N_LANGUAGE_EXPLICIT_KEY) === "1";
    if (explicito && suportado(salvo)) return salvo;
    if (salvo !== null) storage.removeItem(I18N_LANGUAGE_KEY);
    if (storage.getItem(I18N_LANGUAGE_EXPLICIT_KEY) !== null) storage.removeItem(I18N_LANGUAGE_EXPLICIT_KEY);
  } catch {
    /* storage indisponível */
  }
  return IDIOMA_PADRAO;
}

/** Grava a escolha feita no seletor de idioma. */
export function salvarIdiomaEscolhido(storage: StorageLike | null | undefined, lng: IdiomaSuportado): void {
  if (!storage) return;
  try {
    storage.setItem(I18N_LANGUAGE_KEY, lng);
    storage.setItem(I18N_LANGUAGE_EXPLICIT_KEY, "1");
  } catch (error) {
    console.warn("[I18N] Erro ao salvar idioma no localStorage:", error);
  }
}
